import { Modal, message, Radio, Spin, Button } from "antd";
import { useAuth } from "../../../../store/AuthContext/AuthContext";
import { useContext, useEffect, useState } from "react";
import { authRequest } from "../../../../common/request/authRequest";
import { customRequest } from "../../../../common/request/customRequest";
import { StopOutlined } from "@ant-design/icons";
import { GlobalVariableContext } from "../../../../store/GlobalVariableContext/GlobalVariableContext";
import { DrawerPanelTitle, modalPanelStyles } from "../../../pages/common/Drawers/DrawerPanelTitle";

export default function EditLocationVirtualGroupsModal(props: { location: any, onChange: any }) {
  
  const [groups, setGroups] = useState<any>(null);
  const [loading, setLoading] = useState(true);  
  const [selectedGroup, setSelectedGroup] = useState<string | null>(props.location?.label || null);
  const { projectGroup } = useAuth();
  const { updateGlobalData, setUpdateGlobalData } = useContext(GlobalVariableContext)
       
  useEffect(() => {
    // Obtenemos los grupos disponibles
    authRequest(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/virtual`, {})
      .then((response) => {
        setGroups(response);
      })
      .catch(() => {
        //message.error('Error al cargar grupos virtuales');
      })
      .finally(() => {
        setLoading(false); 
      });
  }, [projectGroup.project]); 

  const handleSave = async () => {
    
    try {

      const url = `${process.env.REACT_APP_API}/projects/${projectGroup.project}/virtual/${props.location.composeId}`;
      
      await authRequest(url, { 
        method: 'PATCH', 
        data: { color: selectedGroup } 
      });      
      
      message.success("Etiqueta asignado correctamente");
      setUpdateGlobalData(!updateGlobalData)
      props.onChange(); 
    } catch (e) {
      message.error("Error al guardar la selección");
    }
  };

  return (
    <Modal 
      open={true} 
      onOk={handleSave} 
      onCancel={props.onChange}
      width={640}
      {...modalPanelStyles}
      title={<DrawerPanelTitle title="Asignar región" location={props.location} />}
      destroyOnClose
    >
      <br/>
      {loading ? (
        <div style={{ textAlign: 'center', padding: '20px' }}><Spin /></div>
      ) : (
        <Radio.Group 
          onChange={(e) => setSelectedGroup(e.target.value)} 
          value={selectedGroup}
          style={{ width: '100%' }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            
            {/* Opción para quitar el grupo */}
            <Radio value={null} style={{ padding: '8px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#bfbfbf' }}>
                <StopOutlined />
                <span>Sin región</span>
              </div>
            </Radio>

            {/* Renderizamos solo los grupos que tienen nombre */}
            {groups && Object.entries(groups)
              .filter(([_, name]: [string, any]) => name && name.trim() !== "")
              .map(([color, name]: [string, any]) => (
                <Radio key={color} value={color} style={{ padding: '8px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{ width: 12, height: 12, borderRadius: '50%', backgroundColor: color }} />
                    <span>{name}</span>
                  </div>
                </Radio>
            ))}
          </div>
        </Radio.Group>
      )}
    </Modal>
  );
}
